export default __webpack_public_path__ + "static/linkedinicon-437f13f2b9e4faf6d83beec5a67c686b.svg";